import { passTypeForProductId, type PassType } from "@/types/pass";

export const COMPLETE_SALES_END_AT = "2026-10-25T00:00:00+09:00";
export const MEMBERSHIP_SALES_ORDER: readonly PassType[] = ["free", "starter", "premium", "intelligence"];

export function isCompleteSalesEnded(now: number | string | Date = Date.now()): boolean {
  return new Date(now).getTime() >= Date.parse(COMPLETE_SALES_END_AT);
}

export function isDiscontinuedCompleteProduct(productId: string, now?: number | string | Date): boolean {
  return passTypeForProductId(productId) === "complete" && isCompleteSalesEnded(now);
}
